<template>
  <div class="banks_tags">
    <AddBanksTags />
    <EditBanksTags />
  </div>
</template>
<script>
import AddBanksTags from "./BanksTags/AddTags.vue";
import EditBanksTags from "./BanksTags/EditTags.vue";
export default {
  name: "banks_tags",
  components: { AddBanksTags, EditBanksTags },
  data: () => ({}),
  props: {},
  methods: {},
  created() {},
  mounted() {},
  watch: {},
};
</script>
<style lang="sass" scoped>
</style>
